<template>
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:table-heading>
      <th
        class="text-uppercase text-secondary text-dark font-weight-bolder opacity-7"
      >
        #Invoice Number
      </th>
      <th
        class="text-uppercase text-dark text-secondary font-weight-bolder opacity-7"
      >
        Patient Name
      </th>
      <th
        class="text-uppercase text-secondary text-dark font-weight-bolder opacity-7 ps-2"
      >
        Insurance Company
      </th>
      <th
        class="text-uppercase text-secondary text-dark font-weight-bolder opacity-7 ps-2"
      >
        Bill Amount
      </th>
      <th
        class="text-center text-uppercase text-secondary text-dark font-weight-bolder opacity-7"
      >
        Bill Processing Date
      </th>
      <!-- <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Gender
      </th> -->

      <th class="text-secondary opacity-7"></th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td>#{{ user.id }}</td>
        <td>
          <div class="d-flex px-2 py-1">
            <div></div>
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-sm">{{ user.name }}</h6>
              <p class="text-xs text-secondary mb-0">
                {{ user.email == null ? "--" : user.email }}
              </p>
            </div>
          </div>
        </td>
        <td>{{ user.insurer_name }}</td>
        <td>Ksh. {{ user.total_amount }}</td>
        <td class="align-middle text-center text-sm">
          <soft-badge color="success" variant="gradient" size="sm">{{
            formatDateTime_int(user.created_at)
          }}</soft-badge>
        </td>
        <!-- <td class="align-middle text-center">
          <span class="text-secondary text-xs font-weight-bold">{{
            user.gender == null
              ? "--"
              : user.gender == 1
              ? "Male"
              : user.gender == 2
              ? "Female"
              : "Other"
          }}</span>
        </td> -->
        <td class="align-middle">
          <a
            :href="'/invoices/insurance/invoiceDetail/' + user.id"
            style="
              border: 1px solid black;
              padding: 4px;
              color: green;
              font-weight: bold;
            "
            data-toggle="tooltip"
            data-original-title="Edit user"
            >Detail</a
          >
        </td>
      </tr>
      <tr></tr>
    </template>
  </BaseLayout>
</template>

<script>
// import { generalApiRequest } from "../../api/apiIndex.js";
// import Pagination from '../components/pagination.vue';
import BaseLayout from "../Patients/components/table_page_layout.vue";
// import formatDateTime from "../../timezone/utc_local_time.js";
import formatDateTime from "../../timezone/utc_local_time";

//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      users: [],
      // visit_id: this.$route.params.storeLocation,
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
      searchUrl: "get_all_insurance_invoices_search",
      mainUrl: "get_all_insurance_invoices",
    };
  },
  components: {
    BaseLayout,
    // Search
  },

  methods: {
    handle_external_mount(payload) {
      this.users = payload;
      console.log(this.users);
    },
    formatDateTime_int(payload) {
      return formatDateTime(payload);
    },
  },

  mounted() {
    // this.callApi();
  },
};
</script>

<style scoped>
/* container */
.table-container {
  width: 100%;
}

/* base table */
.table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse; /* needed for clean borders */
  background: #fff;
}

/* table cells */
.table th,
.table td {
  word-wrap: break-word;
  white-space: normal;
  font-size: 0.8em;
  color: black;
  padding: 8px 10px;
  border: 1px solid #4a4a4a; /* <-- border added */
}

/* header row */
.table th {
  background: #f0f0f0;
  font-weight: bold;
}

/* hover effect */
.table tbody tr:hover {
  background: #f9f9f9;
  cursor: pointer;
}
</style>
